export const FORM_QUERY_PARAM = "form";

export function isFormModalHref(href: string | null | undefined) {
  return Boolean(href && href.startsWith(`?${FORM_QUERY_PARAM}=`));
}
